<app-launch-field-container 
[basespaceFormControl]="formControl"
labelPaddingLeft="0px">
    <div class="radio-group-container" 
         [ngClass]="{ 'radio-group-container--tabular': formControl.tabularFieldSetStyling }">
        <rad-radio-group 
        [formControl]="formControl" 
        class="rad-theme--light"
        (focus)="onFocus()">
            <rad-radio 
            *ngFor="let choice of formControl.choices" 
            [attr.value]="choice.value"
            [attr.checked]="choice.value === formControl.value">{{choice.label}}</rad-radio>
        </rad-radio-group>
    </div>
    
</app-launch-field-container>